import { Outlet } from 'react-router-dom'

import { AppBar, Box, Toolbar } from '@mui/material'

import { useDrawer } from '../hooks/useDrawer'
import Header from './Header'
import MainContent from './MainContent'
import Sidebar from './Sidebar'
import { headerHeight } from '../store/constant'

export default function MainLayout() {
  const { drawerOpen } = useDrawer()

  return (
    <Box sx={{ display: 'flex', backgroundColor: 'grey.200' }}>
      <AppBar
        enableColorOnDark
        position='fixed'
        color='inherit'
        elevation={0}
        sx={{ bgcolor: 'grey.200' }}
      >
        <Toolbar sx={{ p: 2, height: headerHeight }} className='toolbar'>
          <Header />
        </Toolbar>
      </AppBar>

      <Sidebar />

      <MainContent drawerOpen={drawerOpen}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: `calc(100vh - ${headerHeight}px)`,
            top: headerHeight,
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </MainContent>
    </Box>
  )
}
